<template>
  <div class="bottom">
      <img class="bg" :src="$config.IMG_URL+'/bg_bot.jpg'" />
      <div class="content">
        <div class="top row justify-between items-start">
          <ul class="row justify-between items-start">
            <li>
              <div class="title">中智安心保险</div>
              <div class="txt">
                <!--a target="_blank" href="http://www.51joying.com/Web/Account/AboutUs.aspx">关于我们</a-->
                <a target="_blank" href="http://tijian.51joying.com/index/about">关于我们</a>
                <a>加入我们</a>
              </div>
            </li>
            <li>
              <div class="title">关于我们</div>
              <div class="txt">
                <a @click="showModalYinsi = true">隐私政策</a>
                <a @click="showModalErtong = true">儿童须知</a>
              </div>
            </li>
            <li>
              <div class="title">发现</div>
              <div class="txt">
                <a>网站地图</a>
              </div>
            </li>
          </ul>
          <div class="right">
            <div class="title">400-820-3351</div>
            <div class="txt">周一至周五 08:30-17:15</div>
          </div>
        </div>
        <div class="bottom">
          <div class="name">中智保险经纪(上海)有限公司  | <a href="https://beian.miit.gov.cn/" target="_blank">  沪ICP备11037892号-2 </a> |  Copyright©2012- 2018</div>
          <div class="link">www.51joying.com</div>
          <div style="width:300px;margin:0 auto; padding:20px 0;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402009467" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/static/img/gongan.png" style="float:left;" /><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">沪公网安备 31010402009467号</p ></a>
          </div>
        </div>
      </div>
      <transition name="fade">
        <modal key="ertong" v-if="showModalErtong" @close="showModalErtong = false">
          <template slot="header">儿童个人信息保护规则及监护人须知</template>
            <div>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">本版更新时间：2024年【02】月【20】日</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">本版生效时间：2024年【02】月【20】日</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">中智保险经纪（上海）有限公司（以下称“我们”或“本公司”）深知儿童（指未满十四周岁的未成年人，下同）个人信息和隐私安全的重要性。我们希望通过《儿童个人信息保护规则及监护人须知》（以下称“本规则”）说明我们在收集和使用儿童个人信息时对应的处理规则等相关事宜。在使用中智保险经纪（上海）有限公司产品和服务前，请儿童、儿童的父母或其他监护人（以下统称“监护人”）务必仔细阅读并透彻理解本规则，特别是以粗体/下划线标识的条款应重点阅读，在确认充分理解并同意全部条款后再开始使用。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">监护人特别说明：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">若我们获悉您的孩子不满十四周岁，我们将根据本规则采取特殊措施保护我们获得的您孩子的个人信息。请帮助我们保护您孩子的个人信息和隐私安全，要求他们在您的监护下共同阅读并接受本规则，且应在您的同意和指导下使用本公司服务、提交个人信息。如果您不同意本规则的内容，将可能导致部分本公司服务无法正常使用，或者无法达到我们拟达到的服务效果。您于线上或通过其他方式同意本规则，表示您同意我们按照本规则收集、使用、存储、共享、转移和公开您孩子的个人信息。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">本规则约定了在不同场景下我们处理儿童信息的方式，但只有当您孩子使用本公司服务时，我们才会处理相关信息。如您孩子不使用本公司服务，则我们不会处理您孩子对应的个人信息。除本规则外，在特定产品中，我们还会通过即时告知如弹窗、页面提示等方式，向您及您的孩子说明该产品特定的信息收集目的、范围及使用方式，这些即时告知内容构成本规则的一部分，并与本规则具有同等效力。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">儿童特别说明：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">我们建议：任何儿童参加网上活动都应事先取得监护人的同意。如果您是儿童，请通知您的监护人共同阅读本规则，并在您使用本公司服务、提交个人信息之前，寻求您的监护人的同意和指导。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">本规则适用于我们在中华人民共和国境内通过网络和线下形式通过收集、使用、存储、转移和披露等方式处理儿童个人信息等活动。在儿童个人信息保护规则方面，本规则与《隐私政策》正文条款存在不一致的，本规则条款优先适用，如本规则中未提及的，则以《隐私政策》正文条款为准。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">在阅读完本规则后，如对本规则或与本规则相关的事宜有任何问题，可通过</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">本规则“如何联系我们”章节</span>
                  <span style="font-family:'宋体'; font-size:12pt">所列的反馈渠道联系我们，我们会尽快作出解答。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">本规则将帮助您了解以下内容：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">一、我们如何收集和使用儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">二、我们可能共享、转移或公开的儿童个人信息的情形</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">三、我们如何存储和保护儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">四、如何行使儿童个人信息相关权利</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">五、第三方服务</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">六、本规则的修订</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">七、如何联系我们</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">一、我们如何收集和使用儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）我们会严格履行法律法规规定的儿童个人信息保护义务与责任，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，在征得监护人的同意后处理儿童个人信息：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">按照理赔申请需要，儿童申请理赔时需提供就诊发票、就诊记录、儿童身份信息复印件和其他就诊资料。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">如我们需要超出上述范围处理儿童个人信息，我们将再次征得监护人的同意。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）征得授权同意的例外</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">根据相关法律法规规定，以下情形中处理儿童的信息无需征得儿童和/或监护人的授权同意：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">1.为订立、履行儿童作为一方当事人的合同所必需；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">2.为履行法定职责或者法定义务所必需；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">3.为应对突发公共卫生事件，或者紧急情况下为保护您或儿童或他人的生命健康和财产安全所必需；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">4.为公共利益实施新闻报道、舆论监督等行为，在合理范围内收集的个人信息；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">5.在合理范围内收集监护人自行公开或者其他已经合法公开的个人信息；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">6.法律、行政法规规定的其他情形。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）有关敏感个人信息的告知提示</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">儿童的个人信息属于敏感个人信息。除了法律有明确规定可以不征求儿童和监护人的同意之外，在收集儿童个人信息前，我们会告知儿童及监护人明确的目的和必要性，以及对个人权益的影响，并征得监护人的单独同意，若监护人不同意，则我们不会进行收集。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">二、我们可能共享、转移或公开的儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）共享</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">未经监护人的同意，我们不会与中智保险经纪（上海）有限公司之外的任何第三方提供儿童的个人信息，但我们可能在下述场景下请求监护人的授权同意：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">1.实现本规则第一条“</span>
                  <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline">我们如何收集和使用儿童个人信息</span>
                  <span style="font-family:'宋体'; font-size:12pt">”部分所述目的，向儿童提供我们的服务。我们可能向合作伙伴及其他第三方共享儿童的信息，以实现本公司服务的功能，让儿童正常使用需要的服务，例如：办理商业保险。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">如需进一步了解合作伙伴及其他第三方信息，请通过本规则“如何联系我们”章节所列的反馈渠道联系我们，我们会尽快作出解答。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">2.与关联公司的必要共享。为便于我们基于统一的帐号体系向儿童提供一致化服务以及便于其进行统一管理、保障系统和帐号安全等，儿童的个人信息可能会在中智保险经纪（上海）有限公司与关联公司之间进行必要共享。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们仅会出于合法、正当、必要、特定、明确的目的共享儿童个人信息。对我们与之共享个人信息的公司、组织和个人，我们会进行安全评估，并与其签署严格的保密协定，要求他们按照我们的说明、本规则以及其他任何相关的保密和安全措施来处理信息。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）转移</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">随着我们业务的持续发展，我们可能发生合并、收购、资产转让、分立、解散、被宣告破产或类似情况，儿童的个人信息有可能作需要转移</span>
                  <span style="font-family:'宋体'; font-size:12pt">。</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">我们将会把相关情况告知儿童及监护人，向儿童及监护人告知接收方的名称和联系方式，并会要求新的接收方按照法律法规及不低于本规则的的要求继续保护儿童的个人信息。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）公开</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会公开儿童个人信息：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">1.根据儿童或监护人的需求，在监护人同意的披露方式下披露其所指定的信息；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">2.根据法律、法规的要求、强制性的行政执法或司法要求所必须提供儿童信息的情况下，我们可能会依据所要求的信息类型和公开方式公开儿童的信息。在符合法律法规的前提下，当我们收到上述公开信息的请求时，我们会要求接收方必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">根据法律规定，共享、转移、公开经匿名化处理的儿童个人信息，且确保儿童个人信息接收方无法复原并重新识别信息主体的，不属于儿童个人信息，对此类信息的保存及处理将无需另行向监护人通知并征得监护人的同意。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">三、我们如何存储和保护儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）存储地点</span>
              </p>
              <p style="margin-top:0pt; margin-right:7.95pt; margin-bottom:0pt; text-indent:24pt; line-height:12pt; background-color:#ffffff">
                  <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">我们仅在中国大陆地区收集和存放儿童个人信息。因业务需要，将来如需跨境传输或存储的，我们将按照《中华人民共和国个人信息保护法》《儿童个人信息网络保护规定》等相关法律法规进行安全评估，并会向监护人及儿童告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及监护人及儿童向境外接收方行使《中华人民共和国个人信息保护法》规定权利的方式和程序等事项，并征得监护人及儿童的同意。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）除法律法规或监管部门另有规定外，我们仅在本规则所述目的必需且最短时限内存储儿童个人信息</span>
                  <span style="font-family:'宋体'; font-size:12pt">。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">如我们终止服务或运营，我们将及时停止继续收集儿童个人信息的活动，同时会遵守相关法律法规要求提前向监护人通知，并在终止服务或运营后对儿童的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">如果监护人主动请求删除儿童个人信息或存储超出必要的期限后，我们将对儿童的个人信息进行删除或匿名化处理，但法律法规规定有保留期限的除外。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）我们非常重视儿童的隐私安全，成立了专门的安全团队，并采取一切合理可行的措施，保护儿童个人信息：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们会采取MD5加密等技术措施存储儿童个人信息，确保信息安全。同时，我们对工作人员以最小授权为原则，严格设定信息访问权限，控制儿童个人信息知悉范围；工作人员访问儿童个人信息的，须经过儿童个人信息保护负责人或者其授权的管理人员审批，记录访问情况，并采取技术措施，避免违法复制、下载儿童个人信息。如我们发现儿童个人信息发生或者可能发生泄露、篡改、丢失的，会立即启动应急预案，采取补救措施，并将事件相关情况以邮件、信函、电话、推送通知、公告等方式告知受影响的监护人和儿童。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">如您希望了解更多，请查阅《隐私政策》</span>
                  <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline">“我们如何保护您的个人信息”“我们如何存储您的信息”章节</span>
                  <span style="font-family:'宋体'; font-size:12pt">，详细了解我们如何存储和保护儿童个人信息。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。监护人需要了解，儿童使用本公司服务所用的系统、通讯网络和材料寄送渠道，有可能因我们可控范围外的情况而发生问题。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">请监护人和儿童务必妥善保管好本公司服务帐号、密码、授权人信息、材料传递信息及其他身份验证要素。儿童在使用本公司服务时，我们会通过授权人信息、材料传递信息及其他身份验证要素来识别其身份。一旦监护人和儿童泄露了前述信息，可能会蒙受损失，并可能对自身产生不利影响。如监护人和儿童发现以上要素可能或已经泄露时，请立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">四、如何行使儿童个人信息相关权利</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">在儿童使用本公司服务期间，监护人和儿童如想查询、复制、更正、补充、转移、删除儿童个人信息，以及注销儿童注册帐号，可以根据使用的本服务具体设置和要求操作，也可以根据本规则</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">“如何联系我们”章节</span>
                  <span style="font-family:'宋体'; font-size:12pt">所列的联系渠道联系我们处理。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">在查询、复制、更正、补充、转移、删除前述信息或申请注销帐号时，我们可能会要求监护人和/或儿童进行身份验证，以保障信息安全。除法律法规另有规定，当监护人和儿童更正、补充、转移、删除儿童个人信息或申请注销帐号时，我们可能不会立即从备份系统中更正或删除相应的信息，但我们会立即停止处理相关信息并会在备份更新时更正或删除或将这些信息匿名化处理。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）查询和复制儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">监护人和儿童可以查看并复制其在使用本公司服务中提供或产生的儿童个人信息，例如个人理赔资料。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）更正和补充儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们鼓励监护人和儿童更新和修改儿童个人信息以使其更准确有效。监护人和儿童发现我们收集、使用和处理的儿童个人信息有错误或不完善的，可以联系我们更正或补充。我们会在完成身份验证和核实问题后，及时采取措施予以更正或补充。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）转移和删除儿童个人信息</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">在请求符合国家网信部门规定条件的情况下，我们将向监护人提供信息转移的途径。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">根据儿童选择本公司服务的具体情况，监护人和儿童可以在使用本公司服务中请求删除部分儿童个人信息。在以下情形下，监护人和儿童可以直接向我们提出删除儿童个人信息的请求，我们会在完成身份验证和核实问题后及时采取措施予以删除，包括：</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">1.我们违反法律法规的规定或者与监护人和儿童的约定收集、存储、使用、转移、公开儿童个人信息的；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">2.超出目的范围或者必要期限收集、存储、使用、转移、公开儿童个人信息的；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">3.监护人撤回同意的；</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">4.监护人或儿童通过注销等方式终止使用本公司服务的。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">但请注意，若监护人和儿童请求我们删除特定的儿童个人信息，可能导致无法继续使用全部或部分本公司服务。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（四）改变授权同意的范围</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">监护人和儿童总是可以选择是否公开信息。有些信息是使用本公司服务所必需的，但大多数其他信息的提供是自行决定的。监护人和儿童可以通过删除信息、关闭设备功能等方式改变其授权我们继续收集信息的范围或撤回其授权。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">当监护人和儿童撤回授权后，我们无法继续提供撤回授权所对应的服务，也不再处理相应的信息。但撤回授权的决定，不会影响此前基于监护人和儿童的授权而开展的信息处理。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">五、第三方服务</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">本公司服务过程中，涉及到儿童业务由第三方提供的，请查阅</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">《隐私政策》“我们如何共享、转让、公开披露您的个人信息”章节</span>
                  <span style="font-family:'宋体'; font-size:12pt">，详细了解我们接入或链接的第三方服务类型。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">本规则仅适用于我们所收集的个人信息，并不适用于任何第三方自主为儿童提供的服务或第三方的信息使用规则。如监护人和儿童发现这些第三方服务存在风险时，建议终止相关操作以保护儿童的合法权益并及时与我们取得联系。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">六、本规则的修订</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">为了提供更好的服务，我们可能会根据本公司服务的更新情况及法律法规的相关要求适时修改本规则的条款，该等修改构成本规则的一部分。如该等更新造成监护人和儿童在本规则下权利的实质减少或重大变更，我们将在本规则生效前通过网站公告、推送通知、弹窗提示或其他方式来通知，监护人如果不同意该等变更，可以选择要求儿童停止使用本公司服务。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们的任何修改都会将用户的满意度置于首位。我们鼓励监护人和儿童在每次使用本公司服务时都查阅我们的《儿童个人信息保护规则及监护人须知》。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">七、如何联系我们</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">我们设有个人信息保护专职部门并指定了专门的儿童个人信息保护负责人，将严格按照本规则保护儿童个人信息。如监护人和儿童有关于网络信息安全的投诉和举报，或对本规则、措施的相关事宜有任何问题、意见或建议，</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">请随时与我们联系，可发送邮件至邮箱</span>
                  <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline">zzbxyiliao.zzbx@ciichr.com</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">或写信至以通信地址：上海市徐汇区沪闵路9299号9楼901室、902室，安心理赔（收）；邮编：</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">200030</span>
                  <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">一般情况下，我们将在收到问题、意见或建议，并验证监护人和</span>
                  <span style="font-family:'宋体'; font-size:12pt">/或儿童身份后的十五个工作日内予以回复。如监护人或儿童不满意我们的回复，还可以向消费者权益保护部门投诉或向有管辖权的法院提起诉讼。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.8pt">
                  <span style="font-family:'宋体'; font-size:12pt">本公司服务提供者是中智保险经纪（上海）有限公司（注册地址：上海市徐汇区沪闵路9299号9楼901室、902室）。</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
                  <span style="font-family:'宋体'">&#xa0;</span>
              </p>
              <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-size:9pt">【历史版本】</span>
                <ul>
                  <li>
                    <span style="font-family:'微软雅黑'; font-size:9pt"><a target="_blank" href="https://mp.weixin.qq.com/s/rLbres5-ByZ8EFjyMWnB-A" >儿童个人信息保护规则及监护人须知（2023年6月1日版）</a></span>
                  </li>
                </ul>
            </p>
          </div>
          </modal>
        <modal v-if="showModalYinsi" @close="showModalYinsi = false">
          <template slot="header">隐私政策</template>
          <div>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">更新日期：【2025】年【11】月【18】日</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">生效日期：【2025】年【11】月【20】日</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">欢迎您使用我们的产品和服务！</span>
                <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline">中智保险经纪（上海）有限公司</span>
                <span style="font-family:'宋体'; font-size:12pt">（以下称“我们”）深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求采取相应的安全保护措施，致力于保护您的个人信息安全。您在使用我们的产品和服务时，我们可能会收集和使用您的相关信息。我们希望通过《隐私政策》（以下称“本隐私政策”或“本政策”）向您说明我们在您使用我们的产品和服务时如何收集、使用、共享、存储和保护您的个人信息，以及您可以如何管理您的个人信息。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">粗体/粗体下划线</span>
                <span style="font-family:'宋体'; font-size:12pt">标识的条款，确保您充分理解和同意后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">本政策将帮助您了解以下内容：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">一、定义及适用范围</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">二、我们如何收集、使用您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">三、我们如何共享、转让、公开披露您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">四、我们如何保护您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">五、我们如何存储您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">六、您如何管理您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">七、我们如何处理未成年人的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">八、本政策如何更新</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; line-height:22.5pt">
                <span style="font-family:'宋体'; font-size:12pt">九、您如何联系我们</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">&#xa0;</span>
            </p>
        </div>
        <br style="page-break-before:always; clear:both; mso-break-type:section-break"/>
        <div>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">一、</span>
                <span style="font-family:'宋体'">定义及适用范围</span>
            </h1>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">（一）定义</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">个人信息：</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">关联公司：</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">是指与</span>
                <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline; background-color:#ffffff">中智保险经纪（上海）有限公司</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">存在关联关系的其他公司。包括不限于：</span>
                <span style="font-family:'宋体'; font-size:12pt; text-decoration:underline">中智保险经纪（上海）有限公司</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">下属全资子公司、控股公司、参股公司，控股股东、控股股东实际控制的其他企业。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">个人敏感信息：</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、不满十四周岁未成年人等的个人信息（我们将在本政策中对具体个人敏感信息以</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">粗体</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">进行显著标识）。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">儿童</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">：指不满十四周岁的未成年人。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">匿名化：</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">通过对个人信息的技术处理，使得个人信息主体无法被识别或者关联，且处理后的信息不能被复原的过程。（注：个人信息经匿名化处理后所得的信息不属于个人信息）</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">去标识化：</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别或者关联个人信息主体的过程。（注：去标识</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">化建立</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">在个体基础之上，保留了个体颗粒度，采用假名、加密、哈希函数等技术手段替代对个人信息的标识）</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">（二）适用范围</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">本政策适用我们及关联公司（以下</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">统称为“中智保险经纪”）以</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; background-color:#ffffff">官方网站（www.51joying.com）</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">的形式向您告知中智主营业务涉及的各项主要产品和服务。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">中智保险经纪主营业务为保险经纪服务，包括：保险经纪各项业务服务。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">二、</span>
                <span style="font-family:'宋体'">我们如何收集和使用您的个人信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">为了向您提供产品和服务</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">并不断优化</span>
                <span style="font-family:'宋体'; font-size:12pt">我们</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">的产品和服务，保障业务安全，</span>
                <span style="font-family:'宋体'; font-size:12pt">我们</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">会通过以下业务形态并按照二（一）章节末尾描述的方式收集、使用您的个人信息：</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:'宋体'; font-weight:bold">（一）中智保险经纪主要产品和服务所必须收集的个人信息</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1、保险商城</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">保险商城是指中智保险经纪为客户、员工提供在线购买各类商业保险的服务。</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">中智保险经纪根据客户需求，制订综合、高效的商业保险解决方案，为客户提供专业的保险经纪服务。中智保险经纪通过全国性的服务网络和行业领先的数字化服务平台，并结合互联网等技术手段，协助客户购买商业保险，用我们的专业服务换取您的满意体验。</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2、理赔服务</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">中智保险经纪理赔团队不进提供理赔进度的跟进，更为您提供全面的理赔分析报告，我们始终站在用户的角度，维护您的权益。</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3、健康管理服务</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">中智保险经纪的健康管理服务是指中智保险经纪依据与客户签订的合同，通过资源整合为客户员工提供健康管理、健康保障等服务。中智为客户员工提供和制订健康服务方案，并根据服务内容和服务标准，组织人员或与供应商合作完成健康服务。</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">我们根据与客户签订的合同提供相关产品及服务，我们需要向签约客户或雇员收集业务办理所必要的个人信息，此时个人信息均在客户或雇员的授权同意下进行操作，我们不会收集非必要的个人信息。</span>
            </p>
            <p style="margin-top:14pt; margin-bottom:14pt; text-indent:24pt; font-size:12pt">
                <span style="font-family:'宋体'; font-weight:bold">（二）收集和使用个人信息的其他规则</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1.若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，均会事先获得您的同意。我们收集及使用上述信息的目的是为了更好地提供服务，并且会通过包括但不限于网站通知、电子邮件、电话或短信息等方法通知。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2.征得授权同意的例外</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">根据相关法律法规规定，我们在以下情况下收集、使用您的个人信息无需您的授权同意：</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(1)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(2)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">为履行法定职责或者法定义务所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(3)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(4)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(5)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">依照有关法律规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21.25pt; margin-bottom:0pt; text-indent:-21.25pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">(6)</span>
                <span style="font:7pt 'Times New Roman'">&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt">法律、行政法规规定的其他情形。</span>
            </p>
            <h1 style="margin-top:0pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">三、我们如何共享、转让、公开披露您的个人信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）共享</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们不会与本产品和服务以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1．在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2．我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3．与授权合作伙伴共享：</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，</span>
                <span style="font-family:'宋体'; font-size:12pt">我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何目的。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们将必要个人信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">目前，我们的授权合作伙伴包括</span>
                <span style="font-family:'宋体'; font-size:12pt">：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline">提供商业保险服务、体检和健康产品服务的第三方公司</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">如您需进一步了解供应商、服务提供商和其他合作伙伴信息，请通过本政策第九节中的联系方式与我们联系，我们会尽快作出解答。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）转让</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1．在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2．在我们涉及合并、收购、出售或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）公开披露</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们仅会在以下情况下，公开披露您的个人信息：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1．获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2．基于法律的披露：在法律、法律程序、诉讼或政府主管部门/监管机构的强制性要求/调查的情况下，我们可能会公开披露您的个人信息。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;&#xa0;根据相关法律法规规定，以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1.为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2.为履行法定职责或者法定义务所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">5.依照有关法律规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">6.法律、行政法规规定的其他情形。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">四、我们如何保护您的个人信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）数据安全技术措施</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们会采用符合业界标准的安全防护措施，安全技术解决方案来防止您的信息遭到未经授权的访问、使用、篡改,避免数据的损坏丢失或泄露。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）我们采取的数据保护管理组织措施</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们通过从组织建设、制度设计、人员管理、产品技术等方面多维度提升个人信息的安全性。同时，我们仅允许有必要知晓这些信息的员工访问您的信息，并为此设置了严格的访问权限控制和监控机制。对于关键岗位员工录用前我们都会经过背景调查，我们同时要求可能接触到您的信息的所有人员签订保密协议并履行相应的保密义务。我们也会定期开展关于个人信息和隐私保护的相关培训，不断提升员工对于用户个人信息和隐私的保护意识。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; font-size:12pt">
                <span style="font-family:'宋体'; font-weight:bold">（三）账户安全风险的自主防范</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">互联网并非绝对安全的环境，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络中智客服或通过本政策第九节提供的联络方式向我们联系，以便我们根据您的申请采取相应措施。请使用复杂密码，协助我们保证您的账号安全。我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（四）个人信息安全事件处置</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">五、我们如何存储您的信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt">
                <span style="font-family:Calibri">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）存储地点</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.95pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">我们仅在中国大陆地区收集和存放您的个人信息。因业务需要，将来如需跨境传输或存储的，我们将按照《中华人民共和国个人信息保护法》、《数据出境安全评估办法》的相关规定进行安全评估，并会向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及您向境外接收方行使中华人民共和国相关法律法规规定权利的方式和程序等事项，并征得您的同意。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.95pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）存储期限</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">&#xa0;&#xa0;</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline; background-color:#ffffff">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。</span>
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">在超出保留期限后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">六、您如何管理您的信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">您还可以通过以下方式访问及管理您的信息：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（一）查询、更正和补充您的信息</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; background-color:#ffffff">您有权查询、更正或补充您的信息。您可以通过线下电话或线上邮箱的方式联系我们客服查询、</span>
                <span style="font-family:'宋体'; font-size:12pt">更正或补充您的信息。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt"></span>
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（二）删除您的个人信息</span>
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold"></span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">在以下情形中，我们会主动删除个人信息，如未删除，您可以向我们提出删除个人信息的请求：</span>
            </p>
            <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1.如果我们处理个人信息的行为违反法律法规；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2.如果我们收集、使用您的个人信息，却未征得您的同意；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3.如果我们处理个人信息的行为违反了与您的约定；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">4.如果您不再使用我们的产品或服务；</span>
            </p>
            <p style="margin-top:0pt; margin-left:21pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">5.如果我们不再为您提供产品或服务。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold; text-decoration:underline; background-color:#ffffff">当您自行或要求我们协助您删除相关信息后，因为适用的法律和安全技术限制，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并限制对其的任何进一步的处理，直到备份数据可以清除或实现匿名化。</span>
            </p>
            <p style="margin-top:0pt; margin-right:7.8pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:12pt; background-color:#ffffff">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">&#xa0;</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt; font-weight:bold">（三）改变您授权同意的范围</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">您可以改变您授权我们继续收集个人信息的范围或撤回您的授权。当您收回授权后，我们将不再处理相应的个人信息。但您收回授权的决定，有可能会影响我们此前基于您的授权而开展的个人信息处理。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">您可以改变或者收回您授权我们收集和处理您的个人信息的范围，但请注意，对于部分类型的个人信息，例如为实现业务功能所必须的信息或者我们履行法律法规规定的义务所必需的信息，我们可能没有办法响应您改变授权范围的请求：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1.为订立、履行您作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2.为履行法定职责或者法定义务所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">5.依照有关法律规定在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">6.法律、行政法规规定的其他情形。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">七、我们如何处理未成年人的信息</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们的产品和服务主要面向成人。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。对于经监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。我们将根据国家相关法律法规及本隐私政策的规定保护未成年人的个人信息。</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">八、本政策如何更新</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">我们的产品、服务以及技术不断跟随您以及其他的用户的需求更新和优化，因此在新的产品、服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所应享有的权利。我们会在专门页面上发布对本政策所做的任何变更。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">对于重大变更，我们还会提供更为显著的通知（例如通过官方网站向您提供弹窗提示）。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">本政策所指的重大变更包括但不限于：</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">1.我们的产品、服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">2.我们在控制权等方面发生重大变化。如并购重组等引起的信息控制者变更等；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">3.个人信息共享、转让或公开披露的主要对象发生变化；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">4.您拥有的个人信息处理方面的权利及其行使方式发生重大变化；</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">5.我们负责处理个人信息保护的责任部门、联络方式及投诉渠道发生变化。</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-align:justify; line-height:16.5pt">
                <span style="font-family:'宋体'; font-size:12pt">&#xa0;</span>
            </p>
            <h1 style="margin-top:14pt; margin-bottom:0pt; font-size:12pt; font-weight:bold">
                <span style="font-family:'宋体'">九、如何联系我们</span>
            </h1>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'宋体'">如果您对本隐私政策有任何疑问、意见或建议、投诉，请通过【</span>
                <span style="font-family:'宋体'; text-decoration:underline">zzbxyiliao.zzbx@ciichr.com</span>
                <span style="font-family:'宋体'">或拨打我们的客服电话</span>
                <span style="font-family:'宋体'; text-decoration:underline">4008203351</span>
                <span style="font-family:'宋体'">、通信地址：</span>
                <span style="font-family:'宋体'; text-decoration:underline">上海市徐汇区沪闵路9299号18楼1806室</span>
                <span style="font-family:'宋体'">】等多种方式与我们联系，我们将在15个工作日内回复您的请求。</span>
                <span style="font-family:'微软雅黑'; font-size:9pt">&#xa0;</span>
                <span style="font-family:'微软雅黑'; font-size:9pt">&#xa0;</span>
                <span style="font-family:'微软雅黑'; font-size:9pt">&#xa0;</span>
                <span style="font-family:'微软雅黑'; font-size:9pt"></span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; text-indent:24pt; text-align:justify; widows:0; orphans:0; font-size:12pt">
                <span style="font-family:'微软雅黑'; font-size:9pt">【历史版本】</span>
                <ul>
                  <li>
                    <span style="font-family:'微软雅黑'; font-size:9pt"><a target="_blank" href="https://mp.weixin.qq.com/s/IWWDUAEou1Fxbj_1lNCToQ" >隐私政策（2025年2月11日版）</a></span>
                  </li>
                </ul>
            </p>
        </div>
        </modal>
      </transition>
    </div>
</template>

<script>
import modal from "./modal";
export default {
  name: "Footer",
  components: {
    modal
  },
  props: {},
  data() {
    return { showModalYinsi: false, showModalErtong: false };
  },
  created() {},
  methods: {}
};
</script>

<style scoped lang="less">
@import "../assets/common";

.bottom {
  width: 100%;
  height: 487px;
  min-width: 1364px;
  position: relative;
  overflow: hidden;
  .bg {
    position: absolute;
    bottom: 0;
    height: 804px;
    left: 50%;
    transform: translate(-50%, 0);
  }
  .content {
    position: relative;
    width: 1364px;
    margin: 0 auto;
    z-index: 10;
    padding-top: 125px;

    .top {
      height: 140px;
      border-bottom: 1px solid #e6e6e6;
    }

    ul {
      width: 915px;
      position: relative;
      li {
        width: 305px;
        position: relative;
        .title {
          white-space: nowrap;
          font-size: 16px;
          line-height: 20px;
          padding-bottom: 20px;
        }
        .txt {
          width: 100%;
          a {
            display: inline-block;
            width: 100%;
            font-size: 16px;
            color: #909090;
            line-height: 20px;
            margin-bottom: 10px;
            &:hover {
              color: @blue;
              cursor: pointer;
            }
          }
        }
      }
    }
    .right {
      text-align: right;
      .title {
        font-size: 30px;
        line-height: 30px;
      }
      .txt {
        font-size: 14px;
        color: #909090;
        line-height: 20px;
        margin-top: 5px;
      }
    }
    .bottom {
      width: 100%;
      text-align: center;
      margin-top: 50px;
      .name {
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 5px;
      }
      .link {
        font-size: 14px;
        line-height: 20px;
        color: #909090;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue